import { useLazyQuery } from '@apollo/client';
import React from 'react';
import { DatabaseTableLineageLabelsQuery, InheritedLabelsColumnFragment } from '../../../../../../../gen-src/queries';
import { FeatureFlagsContext } from '../../../featureFlags/FeatureFlagsContext';
import { useContextWithOverride } from '../HookContext';
import { UseLabelsResultWithExecuteFunction, UseLabelsResult } from '../useRenderLabelsTypes';
import { GetContentLineageLabelsLazyQueryParams, convertLabelsFragmentIntoRenderProps } from './lazyQueryHelper';

export function useDatabaseTableLineageLabelsLazyQueryInheritedLabels({ item, controls, includeParented, includeUpstream, document, contextOverrides }: GetContentLineageLabelsLazyQueryParams): UseLabelsResultWithExecuteFunction {
  const { customSensitivityLabelsEnabled } = useContextWithOverride(FeatureFlagsContext, contextOverrides?.featureFlags);

  const [fire, { loading, error, data }] = useLazyQuery<DatabaseTableLineageLabelsQuery>(document);
  const invoke = React.useCallback(() => { void fire({ variables: { luid: item.contentLuid ?? null, customSensitivityLabelsEnabled } }) }, [fire, item, customSensitivityLabelsEnabled]);

  const upstreamLabels = data?.items[0] ? data?.items[0].upstreamLabels : undefined;
  const parentedItems = data?.items[0] ? data.items[0].columns : undefined;
  const inheritedByCandidates: InheritedLabelsColumnFragment[] | undefined = data?.items[0] ? data.items[0].columns : undefined;
  const result: UseLabelsResult = { loading, error, ...convertLabelsFragmentIntoRenderProps({ upstreamLabels, parentedItems, item, controls, includeParented, includeUpstream, inheritedByCandidates }) };

  return [invoke, result]
}
